<script lang="ts" setup>
import {
  TextStyle,
  TextStyleShade,
} from '@app/customer/Components';
import * as Types from '@app/panel/types/generated';
import { PaperClipIcon } from '@heroicons/vue/24/solid';
import { toLocalDateTime } from '@app/customer/Utils/localDateTime';
import { MarkdownService } from '@app/shared/Services';
import NoteAvatar from './NoteAvatar.vue';

type NoteViewModel = Types.App.Models.ViewModels.NoteViewModel;

defineProps<{
  note: NoteViewModel['note'];
  user: NoteViewModel['user'];
  attachments: NoteViewModel['attachments'];
  customer: NoteViewModel['customer'];
  createdAt: NoteViewModel['createdAt'];
}>();
</script>

<template>
  <div class="flex space-x-4">
    <NoteAvatar
      :user="user"
      :customer="customer"
    />

    <div class="flex flex-col space-y-2">
      <TextStyle
        v-if="user || customer"
        strong
      >
        <span>
          {{ user?.name ?? customer?.name }}
        </span>

        <span v-if="customer">
          (you)
        </span>
      </TextStyle>

      <div
        class="hyphens-auto break-words text-sm prose"
        v-html="MarkdownService.parse(note)"
      />

      <TextStyle :shade="TextStyleShade.Subdued">
        {{ toLocalDateTime(createdAt) }}
      </TextStyle>

      <div class="flex flex-wrap gap-2">
        <template
          v-for="attachment in attachments"
          :key="attachment.id"
        >
          <div class="w-fit cursor-pointer rounded-md bg-blue-50 px-2 py-1.5 hover:bg-blue-100">
            <a
              class="flex items-center space-x-1.5"
              :href="attachment.path"
              target="_blank"
            >
              <PaperClipIcon class="size-4 text-slate-500" />

              <span class="text-xs text-slate-700">{{ attachment.filename }}</span>
            </a>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
